import React from 'react';
import PropTypes from 'prop-types';
import { adopt } from 'react-adopt';
import { Query } from '@apollo/react-components';
import gql from 'graphql-tag';
import get from 'lodash/get';

import { GlobalConsumer } from 'site/context';
import { ContributePageConsumer } from '../context';
import EnterPayment from './enter-payment';

const GET_CAMPAIGN = gql`
    query CampaignById($id: ID!) {
        campaign: campaignById(id: $id) {
            id
            name
            effectiveEnableTips
            enableFundraisers
            metricName {
                singular
            }
            stats {
                performanceActualTotal
                performanceRemaining
            }
            recipient {
                id
                name
                type
                collectAddresses
            }
            owner {
                id
                firstName
                lastName
            }
            shouldDisplayBenefitInHero
            benefits
            matchId
            tags
        }
    }
`;

/* eslint-disable react/prop-types, react/destructuring-assignment */
const Wrapper = adopt(
    {
        global: <GlobalConsumer />,
        context: <ContributePageConsumer />,
        campaignQuery: ({ context, render }) => (
            <Query query={GET_CAMPAIGN} variables={{ id: context.campaign.id }}>
                {render}
            </Query>
        ),
    },
    ({ global, context, campaignQuery }) => ({
        ...global,
        error: campaignQuery.error,
        loading: campaignQuery.loading,
        contribution: context.contribution,
        campaign: get(campaignQuery, 'data.campaign'),
        user: global.user,
    })
);
/* eslint-enable react/prop-types, react/destructuring-assignment */

const EnterPaymentContainer = ({ onSubmit }) => (
    <Wrapper>
        {({ error, loading, campaign, contribution, showFlash }) => {
            if (error) throw error;
            if (loading) return null;

            return (
                <EnterPayment
                    onSubmit={onSubmit}
                    enableTips={campaign.effectiveEnableTips}
                    hasMatch={!!campaign.matchId}
                    isValiantCampaign={campaign.tags.includes('valiant-entry')}
                    contribution={contribution}
                    campaign={campaign}
                    showFlash={showFlash}
                />
            );
        }}
    </Wrapper>
);

EnterPaymentContainer.propTypes = {
    onSubmit: PropTypes.func.isRequired,
};

export default EnterPaymentContainer;
